<template>
  <div class="TravelSportInsuranceForm">
    <h2 class="gl_form-title">
      {{ t(`copy_travel_sport-insurance_form-title-${forWhom}`, answers.forWhomPeople) }}
    </h2>

    <RadioButtonGroupComponent
      id="sport-insurance"
      :options="options"
      :value="sportInsurance"
      v-model="sportInsurance"
      flexDirection="row"
      flexWrap="wrap"
      :rules="[validationRules.required]"
      :scroll="false"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import type TravelConfigurations from '@/modules/travel/common/models/APP/TravelConfigurations'
import type TravelRaterAnswers from '../../models/APP/TravelRaterAnswers'
import { useRules } from '@/modules/core/composables/useRulesComposable'
import RadioButtonGroupComponent from '@/modules/core/components/ui/RadioButtonGroupComponent.vue'
import type { OptionsValuesInterface } from '@/modules/core/models/types'

const { t } = useI18n()
const { required } = useRules()

defineExpose({ triggerSubmit })
interface PropsInterface {
  nextForm: String[]
  answers: TravelRaterAnswers
  configurations: TravelConfigurations
}
const props = withDefaults(defineProps<PropsInterface>(), {})

const sportInsurance = ref(
  typeof props.answers.sportInsurance === 'boolean' ? String(props.answers.sportInsurance) : 'false'
)

const validationRules = {
  required
}

const options: OptionsValuesInterface[] = [
  { label: t('boolean-options.yes'), value: 'true' },
  { label: t('boolean-options.no'), value: 'false' }
]

const forWhom = computed(() => props.answers.forWhom ?? 'me')

function triggerSubmit() {
  const page = props.nextForm[0]
  let destinationType: number | undefined = props.answers.destinationType

  if (
    props.configurations.insuranceTypes.studyAbroad.id === String(props.answers.insuranceType) &&
    sportInsurance.value === 'true' &&
    ![
      props.configurations.destinationTypes.europeAndMediterraneanCoastCountries.id,
      props.configurations.destinationTypes.restOfTheWorld.id
    ].includes(String(destinationType))
  ) {
    destinationType = undefined
  }

  const answers = {
    sportInsurance: sportInsurance.value === 'true',
    destinationType
  }
  return { page, answers }
}
</script>

<style lang="scss" scoped>
.gl_form-title {
  margin-bottom: $spacing-xl;
}
</style>
